export const ProductsImage = [
    "https://s3.amazonaws.com/sygrin/product-photo-1.png",
    "https://s3.amazonaws.com/sygrin/product-photo-2.png",
    "https://s3.amazonaws.com/sygrin/product-photo-3.png",
    "https://s3.amazonaws.com/sygrin/product-photo-4.png",
    "https://s3.amazonaws.com/sygrin/product-photo-5.png",
    "/image/home/products_mor.png"

];